<template>
  <express-template-detail :is-edit='true'>
  </express-template-detail>
</template>

<script>
import ExpressTemplateDetail from './components/ExpressTemplateDetail'
export default {
  name: 'EditTemplate',
  components: {
    ExpressTemplateDetail
  }
}
</script>

